import {TableParams} from "./TableParams";
import {Components} from "../../components";
import {TableOnDraw} from "./TableOnDraw";
import Utilities from "../Utilities";

export class Tables {

    /**
     * Finds each table in the given selector and initialises DataTables on this
     * @param selector
     */
    static init(selector) {
        if($.fn.dataTable === undefined) {
            require('datatables.net-bs4');
            require('datatables.net-responsive-bs4');
            require('datatables.net-buttons-bs4');
            require('datatables.net-buttons');
            require('datatables.net-buttons');
            require('datatables.net-buttons/js/buttons.colVis');
            require('datatables.net-buttons/js/buttons.flash');
            require('datatables.net-buttons/js/buttons.html5');
            require('datatables.net-select-bs4')
        }

        $('table[data-init]', selector).each((key, item) => {
            let table = this.initDataTable(item);

            let $dtClearBtn = $('.dt-clear', selector)

            if ($dtClearBtn.length)
                this.initClearBtn($dtClearBtn, table)


        });
    }

    /**
     * Initialises DataTables on the specified element.
     *
     * @param element
     */
    static initDataTable(element) {
        let $element = $(element),
            table = undefined,
            params = {
                orderCellsTop: true,
                stateSave: true,
                fixedHeader: true,
                responsive: {
                    details: {
                        renderer: function ( api, rowIdx, columns ) {
                            var data = $.map( columns, function ( col, i ) {
                                return col.hidden ?
                                    '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                    '<td>'+col.title+':'+'</td> '+
                                    '<td>'+$('<textarea />').html(col.data).text()+'</td>'+
                                    '</tr>' :
                                    '';
                            } ).join('');

                            return data ?
                                $('<table/>').append( data ) :
                                false;
                        }
                    }
                },
                processing: true,
                drawCallback: function( settings ) {

                    if($element.data('on-draw') !== undefined)
                        TableOnDraw[$element.data('on-draw')](settings, settings.nTable, settings.oInstance.api());

                    new Components($element, false);
                },
                dom: 'rtip',
            };

        //Loading the data from the source defined on the table element
        if($element.data('src') !== undefined) {
            params = Object.assign(params, {
                autoWidth: false,
                serverSide: true,
                ajax: {
                    url: $element.data('src'),
                    type: "POST",
                    data: {
                        _token: window.token.content,
                    }
                }
            });
        }

        //Loading the specific parameters for this table
        if($element.data('init') !== undefined)
            params = Object.assign(params, TableParams[$element.data('init')](params, element));

        table = $element.dataTable(params);

        table.on('responsive-resize.dt', function ( e, datatable, columns ) {
            Tables.drawFilters($element, table);
        });

        this.drawFilters(element, table);

        return table
    }

    static reloadDataTables(selector) {
        $(selector).find('table').each(function () {
            let api = new $.fn.dataTable.Api(this);

            api.ajax.reload();
        });
    }

    static drawFilters(element, datatable) {
        let hasFilters = false;

        $('thead tr.filter-row', element).remove();
        $('thead tr', element).clone(true).addClass('filter-row').appendTo( $('thead', element) );
        $('thead tr:eq(1) th', element).each( function (i) {
            let title = $(this).text(),
                $html = '';

            //Determining which column in the datatables config this represents
            let index = 0;
            $.each(datatable.api().columns().responsiveHidden(), function (key, value) {

                if(value === true && index === i) {
                    index = key;
                    return false;
                } else if(value === true) {
                    ++index;
                }
            });


            let definition = datatable.api().settings()[0].aoColumns[i];

            if(definition.filter === undefined || definition.filter === false || datatable.api().column(index).responsiveHidden() === false) {
                $(this).html('');
                return true;
            }

            hasFilters = true;

            switch(definition.filter.type) {
                case 'companies':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/companies')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'stockLocation':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/stock-locations')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'users':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/users')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'suppliers':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/suppliers')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'statuses':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/statuses')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'label')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'customers':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/customers')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'fullname')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'customerGroups':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/customer-groups')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'variableProducts':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', $(datatable).data('filter-src'))
                        .data('srcValue', 'id')
                        .data('srcLabel', definition.filter.label ?? 'attributes')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'productsSKU':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/products')
                        .data('srcValue', 'sku')
                        .data('srcLabel', 'sku')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'daterangepicker':
                    $html = $('<input type="text" data-toggle="daterangepicker" class="form-control">')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'datepicker':
                    $html = $('<input type="text" data-toggle="datepicker" class="form-control">')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'percent':
                    $html = $('<input type="text" class="form-control">')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'yesNo':
                    $html = $('<select class="form-control"></select>')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());

                    $html.append($('<option value=""></option>'))

                    const options = ['No', 'Yes'];

                    for(let [key, value] of Object.entries(options)) {
                        $html.append($('<option value="' + key + '" ' + (key == datatable.api().column(index).search() ? 'selected' : '') + '>').text(value))
                    }
                    break;
                case 'stockOrderStatus':
                    $html = $('<select class="form-control"></select>')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());

                    $html.append($('<option value=""></option>'))

                    let stockOrderStatuses = ['Delivered', 'Partly Delivered', 'Undelivered', 'Awaiting Delivery'];

                    for(let [key, value] of Object.entries(stockOrderStatuses)) {
                        $html.append($('<option value="' + key + '" ' + (key == datatable.api().column(index).search() ? 'selected' : '') + '>').text(value))
                    }
                    break;
                case 'orderType':
                    $html = $('<select class="form-control"></select>')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());

                    $html.append($('<option value=""></option>'))

                    let orderTypes = ['In Store', 'Telephone', 'Online', 'Purchase Order Instore', 'Purchase Order Telephone']

                    for(let [key, value] of Object.entries(orderTypes)) {
                        $html.append($('<option value="' + value + '" ' + (value == datatable.api().column(index).search() ? 'selected' : '') + '>').text(value))
                    }
                    break;
                case 'couponType':
                    $html = $('<select class="form-control"></select>')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());

                    $html.append($('<option value=""></option>'))

                    const couponsOptions = {'percentage' : 'Percentage', 'flat': 'Flat'};

                    for(let [key, value] of Object.entries(couponsOptions)) {
                        $html.append($('<option value="' + key + '" ' + (key == datatable.api().column(index).search() ? 'selected' : '') + '>').text(value))
                    }
                    break;
                case 'countries':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/countries')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                case 'categories':
                    $html = $('<select class="form-control">')
                        .data('selected', datatable.api().column(index).search())
                        .data('src', '/api/products/categories')
                        .data('srcValue', 'id')
                        .data('srcLabel', 'name')
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
                default:
                    $html = $('<input type="' + definition.filter.type + '" class="form-control">')
                        .val(datatable.api().column(index).search())
                        .addClass('filter-' + definition.name)
                        .attr('placeholder', 'Filter by ' + title.toLowerCase());
                    break;
            }

            $(this).html( $html );

            new Components($(this), false)

            $( 'input, select', this ).on( 'keyup change',
                Utilities.delay(e => {
                    if ( datatable.api().column(index).search() !== e.currentTarget.value ) {
                        datatable.api()
                            .column(index)
                            .search( e.currentTarget.value )
                            .draw();
                    }
                }, 1000))

        }).off('click').removeClass('sorting sorting_desc sorting_asc');

        if(!hasFilters)
            $('thead tr.filter-row', element).remove();
    }

    static initClearBtn($dtClearBtn, table)
    {
        $dtClearBtn.on('click', (e) => {
            $('.filter-row input', table).val('').trigger('change')

            $('.filter-row select', table).each((index, item) => {
                $(item)[0].selectize.clear()
            })
        })
    }
}
